<template>
	<div
		class="button paddingSize"
		:style="{
			marginTop: data.marginTop + 'px',
		}"
	>
		<div
			class="btn"
			v-if="data.content"
			:style="{
				color: data.textColor,
				backgroundColor: data.textBackgroundColor,
				paddingTop: data.paddingTop + 'px',
			}"
			@click="butClick"
		>
			{{ data.content }}
		</div>
		<div class="btn" v-else>默认按钮</div>
	</div>
</template>

<script>
export default {
	name: 'button_component',
	props: ['data'],

	methods: {
		butClick() {
			this.$emit('on-butClick-submit', 'e');
		},
	},
};
</script>

<style lang="scss" scoped>
.button {
	padding-bottom: 50px;
}
.btn {
	width: 80%;
	padding: 8px 0;
	background-color: #f4d5ad;
	border-radius: 18px;
	font-size: 18px;
	font-family: PingFang SC;
	font-weight: bold;
	color: #d10000;
	margin: 0 auto;
	text-align: center;
	white-space: pre-line;
}
</style>